// extracted by mini-css-extract-plugin
export var activityContainer = "_km-0";
export var typingIndicatorContainer = "_km-1";
export var typingIndicatorDot = "_km-2";
export var wave = "_km-3";